<div class="modal-header">
    <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" (click)="close()"><span aria-hidden="true">&times;</span></button>
    <h4 class="modal-title" id="labelButtons">{{data.title}}</h4>
</div>
<div class="modal-body">
    <h2>{{data.header}}</h2>
    {{data.message}}
</div>
<div class="modal-footer">
    <div class="btn--group">
        <button class="btn--default" type="button" (click)="accept()" *ngIf="data.showOkButton">{{data.okButtonText}}</button>
        <button class="btn--default" type="button" (click)="close()">{{data.buttonText}}</button>
    </div>
</div>

